module.exports = __webpack_public_path__ + "img/lt_editor.a539de02.png";